<template>
  <svg width="100%" height="100%" viewBox="0 0 142 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1_8)">
      <circle cx="69" cy="69" r="69" fill="url(#paint0_linear_1_8)"/>
      <circle cx="69" cy="69" r="67.5" stroke="white" stroke-width="3"/>
    </g>
    <path
      d="M43.1254 52.2343C43.7921 49.7343 46.3254 44.4343 51.1254 43.2343C55.9254 42.0343 59.7921 45.7343 61.1254 47.7343C62.4587 49.401 64.7254 53.3343 63.1254 55.7343C61.1254 58.7343 56.1254 62.2343 56.1254 62.2343C56.1254 62.2343 55.1254 63.2343 54.6254 63.7343C54.1254 64.2343 74.7428 85.7343 75.6254 83.2343C76.508 80.7343 83.6254 73.3593 86.6254 75.2343C90.6254 77.7343 94.4825 81.7343 95.1254 83.2343C96.1254 85.5677 95.1254 88.7343 92.1254 92.2343C89.1254 95.7343 78.6254 94.2343 78.6254 94.2343C78.6254 94.2343 71.1254 94.7343 56.1254 82.2343C44.1254 72.2343 42.4587 58.0677 43.1254 52.2343Z"
      fill="white"/>
    <defs>
      <filter id="filter0_d_1_8" x="0" y="0" width="141.6" height="139.6" filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"/>
        <feOffset dx="3" dy="1"/>
        <feGaussianBlur stdDeviation="0.3"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.145098 0 0 0 0 0.231373 0 0 0 0 0.4 0 0 0 1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_8"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_8" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear_1_8" x1="117" y1="19.5" x2="17.5" y2="112" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C5F444" offset="0"/>
        <stop offset="1" stop-color="#56A11D"/>
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%'
    },
  }
}
</script>